import { z } from 'zod';

export const SuspendResponseSchema = z.object({
  suspendPlanId: z.number(),
  suspendPlanGroupId: z.number(),
  preSuspendPlanGroupId: z.number(),
  preSuspendPlanId: z.number(),
  suspendDate: z.string(),
  suspendReasonId: z.number(),
  suspendSubReasonId: z.number(),
});

export type SuspendResponse = z.infer<typeof SuspendResponseSchema>;
